export default "__VITE_PUBLIC_ASSET__4aa71485__"